import { Link } from "react-router-dom";
import { useState } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";
import { saveAs } from "file-saver";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";

export default function EventsTable({ data = [], onDelete, onRefresh }) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerSrc, setViewerSrc] = useState(null);

  const [viewerData, setViewerData] = useState(null);


    const formatDateTime = (iso) => {
      if (!iso) return "-";

      const d = new Date(iso);

      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="overflow-hidden rounded-xl bg-white shadow-sm">
        <table className="w-full text-left">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Event Image
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Event Name
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Start Date
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                End Date
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="px-6 py-4 text-sm font-semibold text-gray-600 text-right">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  className="px-6 py-10 text-center text-sm text-gray-500"
                >
                  No events found
                </td>
              </tr>
            ) : (
              data.map(item => (
                <tr
                  key={item._id}
                  className="hover:bg-gray-50 transition"
                >

                  <td className="px-6 py-4">
  {(() => {
    let mediaPath = null;
    let mediaType = null;

    const defaultMedia = item.default_media;

    if (defaultMedia) {
      if (defaultMedia.type === "image") {
        mediaPath = defaultMedia.value;
        mediaType = "image";
      }

      if (defaultMedia.type === "video") {
        mediaPath = defaultMedia.value;
        mediaType = "video";
      }
    }

    if (!mediaPath) {
      if (item.eventImage?.length > 0) {
        mediaPath = item.eventImage[0];
        mediaType = "image";
      } else if (item.eventVideo?.length > 0) {
        mediaPath = item.eventVideo[0];
        mediaType = "video";
      }
    }

    if (!mediaPath) {
      return (
        <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center text-xs text-gray-400">
          no media
        </div>
      );
    }

    const fullUrl = getImageUrl(mediaPath);

    return mediaType === "image" ? (
      <img
        src={fullUrl}
        alt={item.event_name}
        className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
        onClick={() => {
          setViewerSrc(fullUrl);
          setViewerData({ url: fullUrl, type: "image" });
          setViewerOpen(true);
        }}
      />
    ) : (
      <video
        src={fullUrl}
        className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
        onClick={() => {
          setViewerSrc(fullUrl);
          setViewerData({ url: fullUrl, type: "video" });
          setViewerOpen(true);
        }}
      />
    );
  })()}
</td>




                  <td className="px-6 py-4 font-medium text-gray-800">
                    {item.event_name}
                  </td>

                  <td className="px-6 py-4 text-gray-600">
                    {formatDateTime(item.event_dates?.[0]?.from_date)}
                  </td>

                  <td className="px-6 py-4 text-gray-600">
                    {formatDateTime(item.event_dates?.[0]?.to_date)}
                  </td>


                  <td className="px-6 py-4">
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-semibold ${
                        item.status === "active"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-600"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>


                  <td className="px-6 py-4">
                    <div className="flex justify-end gap-3">
                      <Link
                        to={`/admin/events/view/${item._id}`}
                        title="View"
                        className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-500"
                      >
                        <MdVisibility size={18} />
                      </Link>

                      <Link
                        to={`/admin/events/edit/${item._id}`}
                        title="Edit"
                        className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
                      >
                        <MdEdit size={18} />
                      </Link>

                      <button
                        title="Delete"
                        onClick={() => setDeleteId(item._id)}
                        className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
                      >
                        <MdDelete size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Event"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />

      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerData?.url}
        type={viewerData?.type}
      />

    </>
  );
}
